import { Stack, Typography, SxProps, Theme } from '@mui/material';
import Skeleton from '../Skeleton';

export default function SheetTitle({
  title,
  subtitle,
  sx,
}: {
  title: LocalizedString;
  subtitle?: LocalizedString;
  sx?: SxProps<Theme>;
}) {
  return (
    <Stack gap={0.5} marginBottom={3} sx={sx}>
      <Typography variant="h1" sx={{ lineHeight: '32px' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          sx={{
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
            textWrap: 'pretty',
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
}

SheetTitle.Loading = () => (
  <Skeleton variant="text" height="46px" width="100%" />
);
